import Benefit from "../../modules/benefit/view/Benefit.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import { PermissionList } from "../../static-data/PermissionList";
import { IsAbleNavigation } from "../utils/is-able-navigation";
import HealthPlan from "../../modules/health-plan/views/HealthPlan.vue";
import FuneralAssistance from "../../modules/funeral-assistance/views/FuneralAssistance.vue";
import TemporaryAssistance from "../../modules/temporary-assistance/views/TemporaryAssistance.vue";
import Absence from "../../modules/absence/views/Absence.vue";
import Benefactor from "../../modules/benefactor/views/Benefactor.vue";
import OtherSolicitation from "../../modules/Other-solicitations/views/OtherSolicitations.vue";

const BenefitRoutes = {
  path: "beneficios",
  component: RouterViewRender,
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.BENEFIT_MENU),
  children: [
    {
      path: "",
      component: Benefit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "plano-saude",
      component: HealthPlan,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "benemerito",
      component: Benefactor,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "auxilio-funeral",
      component: FuneralAssistance,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "auxilio-temporario",
      component: TemporaryAssistance,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "afastamento",
      component: Absence,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "outra-solicitacao",
      component: OtherSolicitation,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default BenefitRoutes;
